import React from 'react'
import { Link } from 'react-router-dom'
// import "./index.css"
const Header = () => {
  return (
    <div className='nav'>
      <Link to="/" className='links'>HOME</Link>
      <Link to="/bmicalculator" className='links'>BMI Calculator</Link>
      <Link to="/sicalculator" className='links'>SI Calculator</Link>
      <Link to="/cicalculator" className='links'>CI Calculator</Link>
      <Link to="/calculator" className='links'>Calculator</Link>
      <div id="indicator"></div>
    </div>
  )
}

export default Header
